module.exports = __webpack_public_path__ + "img/service2-3.6f5f6f52.webp";